import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bac4044c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bac4044c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bac4044c')) {
      api.createRecord('bac4044c', component.options)
    } else {
      api.reload('bac4044c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bac4044c", function () {
      api.rerender('bac4044c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/administratorAuthority/permissionRules/index.vue"
export default component.exports